<template>
    <el-dialog :visible.sync="openStatus" class="change-resource-container" :title="$t('eip.text.modifyBandwidth')"
        size="default" :close-on-click-modal="false" @close="doClose()">
        <el-form label-width="105px">
            <el-form-item :label="$t('orderConfirm.text.currentConfig') | withColon">
                <el-table :data="[detailData]">
                    <!--公网IP-->
                    <el-table-column v-if="pageType === 'EIP'" property="elasticIp"
                        :label="$t('listPage.tableLabel.publicIp')" min-width="170">
                        <template slot-scope="scope">
                            <p class="mb0" :title="scope.row.elasticIp + $t('listPage.text.publicIpv4')">
                                {{ scope.row.elasticIp | maybeEmpty }}{{ $t('listPage.text.publicIpv4') }}</p>
                        </template>
                    </el-table-column>
                    <!--共享带宽-->
                    <el-table-column v-if="pageType === 'SBW'" property="name" :label="$t('sbw.text.sbw')" min-width="170">
                        <template slot-scope="scope">
                            <p class="mb0" :title="scope.row.name">
                                {{ scope.row.name | maybeEmpty }}</p>
                        </template>
                    </el-table-column>
                    <!--IPv6地址-->
                    <el-table-column v-if="pageType === 'IPV6'" :label="$t('ipv6.text.ipv6Address')" min-width="170">
                        <template slot-scope="scope">
                            <p class="mb0" :title="scope.row.ipv6Address">
                                {{ scope.row.ipv6Address | maybeEmpty }}</p>
                        </template>
                    </el-table-column>
                    <!--对等链接-->
                    <el-table-column v-if="pageType === 'PEERING'" :label="$t('peering.text.name')" min-width="170">
                        <template slot-scope="scope">
                            <p class="mb0" :title="scope.row.ipv6Address">
                                {{ scope.row.name | maybeEmpty }}</p>
                        </template>
                    </el-table-column>
                    <!--到期时间-->
                    <el-table-column v-if="detailData.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION"
                        property="expire_date" :label="$t('listPage.tableLabel.expireTime')" min-width="170">
                        <template slot-scope="scope">
                            <span>{{ scope.row.charge.chargeExpiredTime | maybeEmpty }}</span>
                        </template>
                    </el-table-column>
                    <!--当前带宽-->
                    <el-table-column property="current_bandwidth" :label="$t('listPage.tableLabel.currentBandWidth')"
                        min-width="126">
                        <template slot-scope="scope">
                            <span>{{ scope.row.bandwidth | maybeEmpty }}Mbps</span>
                        </template>
                    </el-table-column>
                    <!--保底百分比-->
                    <el-table-column v-if="detailData.chargeMode === ChargeModeConstant.ENHANCED_BY_DURATION"
                        property="current_bandwidth" :label="$t('sbw.text.guaranteedPercentage')" min-width="80">
                        <template slot-scope="scope">
                            <span>20%</span>
                        </template>
                    </el-table-column>
                    <!--计费方式-->
                    <el-table-column property="charge" :label="$t('listPage.tableLabel.billMethods')" min-width="124">
                        <template slot-scope="scope">
                            <span>{{ scope.row.chargeModeName | maybeEmpty }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
        </el-form>
        <el-form ref="form" label-width="105px" class="slider-bandwidth" onsubmit="return false">
            <el-form-item :label="$t('listPage.text.maxBandWidth') | withColon">
                <div class="block full-slider">
                    <div class="el-form-item-inline">
                        <el-slider v-model="sliderBandwidth" show-input @change="calPrice" :max="maxBandwidth"
                            :marks="marks" :debounce="1000" :min="minBandwidth" class="jc-slider-custom">
                        </el-slider>
                    </div>
                </div>
            </el-form-item>

            <el-form-item :label="$t('listPage.text.cost') | withColon" v-if="detailData.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION">
                <div class="block full-slider">
                    <div class="el-form-item-inline">
                        <span class="remind">{{ $t('eip.text.feePerHour', [totalFee]) }}</span>
                        <p>{{ $t('create.text.configureMonthPay', [totalFeePerMonth]) }}</p>
                    </div>
                </div>
            </el-form-item>
            <template v-else>
                <el-form-item :label="$t('listPage.text.deploymentRefundFee') | withColon" v-if="detailData.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION && processType === 9">
                    <div class="block full-slider">
                        <div class="el-form-item-inline">
                            <span class="remind">{{ $t('listPage.text.currencySymbol') }}{{ refundTotalPrice }}</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('listPage.text.deploymentSupplementFee') | withColon" v-else>
                    <div class="block full-slider">
                        <div class="el-form-item-inline">
                            <span class="remind">{{ $t('listPage.text.currencySymbol') }}{{ totalFee }}</span>
                        </div>
                    </div>
                </el-form-item>
            </template>

            <template v-if="hasDiscount">
                <el-form-item>
                    <div class="block full-slider">
                        <div class="el-form-item-inline">
                            <span class="price original-total-price">{{ $t('eip.text.originalPrice', [totalPrice]) }}</span>
                            <span class="discounted-total-price">{{ $t('eip.text.discountedPrice', [favorablePricePerHour]) }}</span>
                        </div>
                    </div>
                </el-form-item>
            </template>
        </el-form>
        <!-- <section class="postpaid-price mt30" v-if="detailData.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION">
            <span>{{ $t('listPage.text.cost') + ': ' }}</span>
            <div class="ml5">
                <span class="remind">{{ $t('eip.text.feePerHour', [totalFee]) }}</span>
                <p>{{ $t('create.text.configureMonthPay', [totalFeePerMonth]) }}</p>
            </div>
        </section>
        <template v-else>
            <section v-if="detailData.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION && processType === 9"
                class="mt30">
                <span>{{ $t('listPage.text.deploymentRefundFee') + ': ' }}</span>
                <span class="remind">{{ $t('listPage.text.currencySymbol') }}{{ refundTotalPrice }}</span>
            </section>
            <section v-else class="mt30">
                <span>{{ $t('listPage.text.deploymentSupplementFee') + ': ' }}</span>
                <span class="remind">{{ $t('listPage.text.currencySymbol') }}{{ totalFee }}</span>
            </section>
        </template>
        <p v-if="hasDiscount">
            <span class="price original-total-price">{{ $t('eip.text.originalPrice', [totalPrice]) }}</span>
            <span class="discounted-total-price">{{ $t('eip.text.discountedPrice', [favorablePricePerHour]) }}</span>
        </p> -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="doClose">{{ $t('listPage.text.cancelButton') }}</el-button>
            <el-button type="primary" @click="doConfirm()" :disabled="confirmButtonDisabled">
                {{ $t('listPage.text.sureButton') }}
            </el-button>
        </span>
    </el-dialog>
</template>


<script>

import { ChargeModeMap, CreateTypeConstant, ChargeModeConstant } from '@/common/Constants';
import { changeTwoDecimal, mulDecimals, subDecimals } from '@/common/tool';
let orderUrlMap = {
    'EIP': '/api/cps/eips/modifyBandwidth',
    'SBW': '/api/cps/bandwidthPackages/modifyBandwidth',
    'IPV6': '/api/cps/ipv6Addresses/modifyBandwidth',
    'PEERING': '/api/cps/peerConn/modifyPeerBandwidth'
};
export default {
    data() {
        return {
            openStatus: false,
            // 滑动的带宽值
            sliderBandwidth: 0,
            // 当前的带宽值
            currentBandwidth: 0,
            totalFee: 0,
            totalFeePerMonth: 0,
            totalDiscount: 0,
            totalPrice: 0,
            minBandwidth: 1,
            maxBandwidth: 200,
            expirationDate: '',
            refundTotalPrice: '',
            // 变配明细 1-升配补差价，2-降配延时，3-临时升配，9-降配退款
            processType: '',
            marks: { 1: '1Mbps', 200: '200Mbps' },
            favorablePricePerHour: '', // 省 = 原价 - 应付
        };
    },
    computed: {
        // 确定按钮是否禁用
        confirmButtonDisabled() {
            return (this.sliderBandwidth < this.minBandwidth || this.sliderBandwidth > this.maxBandwidth
                || isNaN(this.sliderBandwidth) || this.bandwidthUnChange);
        },
        // 是否有折扣
        hasDiscount() {
            return this.totalDiscount !== '0.00' && this.totalDiscount !== '0'
                && this.totalDiscount !== 0;
        },
        ChargeModeMap: () => ChargeModeMap,
        CreateTypeConstant: () => CreateTypeConstant,
        ChargeModeConstant: () => ChargeModeConstant,
        bandwidthUnChange() {
            return this.detailData.bandwidth === this.sliderBandwidth
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: true,
        },
        detailData: {
            type: Object,
        },
        pageType: {
            type: String,
            default: 'EIP'
        }
    },
    watch: {
        dialogVisible(val) {
            this.openStatus = val;
            this.sliderBandwidth = this.detailData.bandwidth;
        },
        detailData(value) {
            this.sliderBandwidth = value.bandwidth;
            this.currentBandwidth = value.bandwidth;
            if (this.pageType === 'PEERING') {
                this.maxBandwidth = 10240;
                this.marks = { 1: '1Mbps', 10240: '10240Mbps' };
                if (value.bandwidth > 10240) {
                    this.marks = { 10240: '10240Mbps', 10240: '10240Mbps' }
                    this.minBandwidth = 10240;
                }
            } else {
                if (value.bandwidth > 200) {
                    this.marks = { 200: '200Mbps', 200: '200Mbps' }
                    this.minBandwidth = 200;
                }
            }
        }
    },
    methods: {
        // 关闭弹框
        doClose() {
            this.resetInitParams();
            this.$emit('ifDialogVisible', false);
        },
        // 点击确认按钮，修改弹性公网IP
        doConfirm() {
            this.createTempOrder();
        },
        resetInitParams() {
            this.sliderBandwidth = this.minBandwidth;
            this.processType = '';
            this.totalFee = 0;
            this.totalDiscount = 0;
            this.totalPrice = 0;
            this.totalFeePerMonth = 0;
        },
        calPrice() {
            const gridData = this.detailData;
            const params = {
                cmd: 3,
                resourceId: gridData.elasticIpId || gridData.bandwidthPackageId || gridData.ipv6AddressId || gridData.peerIden,
                region: gridData.region || gridData.senderRegion,
                timeUnit: 3,
                timeSpan: 12,
                bw: this.sliderBandwidth,
                count: 1,
                createType: CreateTypeConstant[this.pageType],
                billingType: gridData.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION ? 3 : gridData.chargeMode === ChargeModeConstant.ENHANCED_BY_DURATION ? 2 : 1 //1 按配置后付费 2 按用量 3 包年包月
            };
            // PREPAID_BY_DURATION: 'prepaid_by_duration', 包年包月
            //   POSTPAID_BY_DURATION: 'postpaid_by_duration', 按配置
            //   ENHANCED_BY_DURATION: 'postpaid_by_usage', 按用量
            let calPriceUrl = '';
            if (gridData.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) { // 包年包月 预付费
                calPriceUrl = "/api/price/billingprice/calculateTotalPrice";
            } else if (gridData.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION || gridData.chargeMode === ChargeModeConstant.ENHANCED_BY_DURATION) { // 按配置 && 按用量 后付费
                calPriceUrl = "/api/price/calculateTotalPrice";
            }
            // @ZTT 测试完成需要删除
            Ajax.get(calPriceUrl, params)
                .then((res) => {
                    const { discountedTotalPrice, totalPrice, totalDiscount, refundTotalPrice, list, totalOriginalPrice } = res?.data || {};
                    this.totalFee = changeTwoDecimal(discountedTotalPrice);
                    this.totalPrice = changeTwoDecimal(totalPrice);
                    this.totalDiscount = changeTwoDecimal(totalDiscount);
                    this.expirationDate = list.length && list && list[0]?.endTime;
                    this.refundTotalPrice = changeTwoDecimal(refundTotalPrice);
                    this.totalFeePerMonth = changeTwoDecimal(mulDecimals(mulDecimals(this.totalFee, 24), 30));
                    this.processType = list && list[0]?.processType;
                    this.favorablePricePerHour = totalDiscount ? changeTwoDecimal(subDecimals(totalOriginalPrice, discountedTotalPrice)) : null;
                })
                .catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                });
        },
        createTempOrder() {
            const param = {
                orderType: 3, // 订单类型 1、新购；2、续费；3、配置变更
                region: this.detailData.region || this.detailData.senderRegion, // 区域
                bw: this.sliderBandwidth, // 带宽
                clientToken: Normal.getClientToken(), // 用于保证请求的幂等性，唯一
                timestamps: Normal.getClientToken(), // 毫秒时间戳
                resourceId: this.detailData.elasticIpId || this.detailData.bandwidthPackageId || this.detailData.ipv6AddressId || this.detailData.peerIden,
                createType: CreateTypeConstant[this.pageType]
            };
            let url = orderUrlMap[this.pageType];
            Ajax.post(url, param)
                .then((res) => {
                    const orderId = res.data.tempOrderNumber;
                    if (orderId) {
                        window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
                    }
                })
                .catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                })
                .finally(() => {
                    this.doClose()
                })
        },
    }
};
</script>

<style lang="scss">
@import '../../../assets/scss/sliderCommon';
@import 'style';

.full-slider {
    width: 100%;
}
</style>

<style lang="scss" scoped>
.change-resource-container {
    .jc-slider-custom {
        margin-left: 8px !important;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/common/modifyBandwidth/ModifyBandwidth.vue